// extracted by mini-css-extract-plugin
module.exports = {"input":"HeaderSearchSpotlight_input__ZH7ZL","actionsList":"HeaderSearchSpotlight_actionsList__4TbgD"};